import * as numberFormatter from "numeral";
import I18n from "../base/i18n.js";

class RawNumberFormatter {

  constructor() {
    if(!numberFormatter.locales.de) {
      numberFormatter.register('locale', 'de', {
        delimiters: {
          thousands: '.',
          decimal: ','
        },
        abbreviations: {
          thousand: I18n.t("format_number.short_thousand"),
          million: I18n.t("format_number.short_million"),
          billion: I18n.t("format_number.short_billion"),
          trillion: I18n.t("format_number.short_trillion")
        },
        currency: {
          symbol: I18n.t("currency.euro")
        }
      });
    }
    numberFormatter.locale('de');
  }

  format(value, format = undefined) {
    return "";
  }
}

const instance = new RawNumberFormatter();
export default instance;
export { RawNumberFormatter };